module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-00.1@2x.20982a9e.jpg";